import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d59729c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "report" }, null, -1))
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "swapBox" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBox" }, "病例启示", -1))
const _hoisted_5 = { class: "topBoxRight" }
const _hoisted_6 = { class: "bakBox" }
const _hoisted_7 = { class: "reportText" }
const _hoisted_8 = { class: "boxTail" }
const _hoisted_9 = { class: "leftright" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, " AR与普通感冒均伴随鼻塞、流涕等鼻部症状，临床容易混淆。可从发病机制、病程、症状等方面进行鉴别 "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_11 = { class: "reportText" }
const _hoisted_12 = { class: "boxTail" }
const _hoisted_13 = { class: "leftright" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, " 依从性对治疗效果有着显著影响。患者曾接受免疫治疗，后又中断。免疫治疗疗程较长，且起效缓慢、治疗较为不便，是影响患者依从性的主要因素 "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_15 = { class: "reportText" }
const _hoisted_16 = { class: "boxTail" }
const _hoisted_17 = { class: "leftright" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "yanjiu" }, [
      /*#__PURE__*/_createElementVNode("div", null, " 辅舒良作为二代鼻用激素，首次使用最快2-4 小时起效，与布地奈德相比，丙酸氟替卡松鼻喷雾剂在减少喷嚏、鼻痒方面效果更为显著 "),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "three" })
      ])
    ])
  ])
], -1))
const _hoisted_19 = { class: "pingzi" }
const _hoisted_20 = { class: "fdjbottom" }
const _hoisted_21 = { class: "backfirst" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_medical = _resolveComponent("medical")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_image, {
        src: require('../assets/logo.png')
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_image, {
          class: "rightImg",
          width: "1.9267rem",
          height: "2.48rem",
          src: require('../assets/dui.png')
        }, null, 8, ["src"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_14
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_van_image, {
                class: "rightImg",
                width: ".6667rem",
                height: ".6667rem",
                src: require('../assets/duigou.png')
              }, null, 8, ["src"])
            ]),
            _hoisted_18
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_van_image, {
            class: "finger",
            width: "3.2267rem",
            height: "4.0267rem",
            src: require('../assets/pingzi.png')
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_van_image, {
            class: "finger",
            width: "6.8267rem",
            height: "1.8133rem",
            src: require('../assets/fdj.png')
          }, null, 8, ["src"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_image, {
            onClick: $options.backfirst,
            width: "3.5467rem",
            height: ".96rem",
            src: require('../assets/backfirst.png')
          }, null, 8, ["onClick", "src"])
        ])
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: $data.show,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event))
    }, {
      default: _withCtx(() => [
        ($data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 0,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true),
        (!$data.flag)
          ? (_openBlock(), _createBlock(_component_medical, {
              key: 1,
              onOnChanged: $options.updateChanged,
              postaimqus: $data.postaimqus
            }, null, 8, ["onOnChanged", "postaimqus"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_toNav, { menu: 5 })
  ], 64))
}